import { render, staticRenderFns } from "./recovery-screen-shimmer.vue?vue&type=template&id=22c22912&scoped=true"
import script from "./recovery-screen-shimmer.vue?vue&type=script&lang=js"
export * from "./recovery-screen-shimmer.vue?vue&type=script&lang=js"
import style0 from "./recovery-screen-shimmer.vue?vue&type=style&index=0&id=22c22912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c22912",
  null
  
)

export default component.exports